<template>
    <div>
        <div
            class="admin-home-card"
            :class="{ clickable: hasRights, disabled: !hasRights }"
            v-tooltip="getTooltip(labelHasNotRights)"
            @click="emitClick(link)">
            <span v-if="link.badge" class="admin-home-card-badge">{{ link.badge }}</span>
            <div class="admin-home-card-icon">
                <feather v-if="typeof link.icon !== 'undefined'" :type="link.icon" />
                <i v-else-if="typeof link.rawIcon !== 'undefined'" v-html="link.rawIcon"></i>
            </div>
            <h6 class="admin-home-card-title text-center">{{ link.name }}</h6>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        link: {
            required: true,
        },
    },
    computed: {
        rights() {
            return this.$store.getters["users/formattedRights"];
        },
        hasRights() {
            if (typeof this.link.rights === "undefined") {
                return true;
            }
            return this.link.rights.some((right) => {
                if (this.rights.includes(right)) {
                    return true;
                }

                const index = right.indexOf("*");
                if (index !== -1) {
                    right = right.substring(0, i).replace(/([.?*+^$[\]\\(){}|-])/g, "\\$1");
                    const regexp = new RegExp(`${right}.+`, "g");
                    return this.rights.some((cright) => cright.match(regexp));
                }
                return false;
            });
        },
        labelHasNotRights() {
            return !this.hasRights ? "Vous n'avez pas le droit d’accéder à cette page" : "";
        },
    },
    methods: {
        emitClick(link) {
            if (this.hasRights) {
                this.$emit("click", link);
            }
        },
    },
};
</script>
<style scoped>
.admin-home-card {
    position: relative;
    display: flex;
    min-height: 126px;
    height: 100%;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 20px 14px 18px;
    overflow: hidden;
    background: rgba(255, 255, 255, 0.94);
    border: 1px solid rgba(21, 126, 194, 0.1);
    border-radius: 14px;
    box-shadow: 0 12px 32px rgba(21, 43, 70, 0.06);
    color: #17293d;
    transition: transform 0.18s ease, border-color 0.18s ease, box-shadow 0.18s ease, background-color 0.18s ease;
}

.admin-home-card-badge {
    position: absolute;
    top: 10px;
    right: 10px;
    padding: 3px 7px;
    border-radius: 999px;
    background: #157ec2;
    color: #fff;
    font-size: 0.62rem;
    font-weight: 700;
    line-height: 1;
    letter-spacing: 0;
}

.admin-home-card.clickable {
    cursor: pointer;
}

.admin-home-card.clickable:hover {
    transform: translateY(-3px);
    background: #ffffff;
    border-color: rgba(21, 126, 194, 0.28);
    box-shadow: 0 16px 36px rgba(21, 43, 70, 0.11);
}

.admin-home-card.disabled {
    opacity: 0.5;
}

.admin-home-card-icon {
    display: flex;
    width: 46px;
    height: 46px;
    align-items: center;
    justify-content: center;
    margin-bottom: 14px;
    color: #2f7fb4;
    background: rgba(21, 126, 194, 0.09);
    border: 1px solid rgba(21, 126, 194, 0.1);
    border-radius: 13px;
    transition: color 0.18s ease, background-color 0.18s ease, border-color 0.18s ease;
}

.admin-home-card-icon svg,
.admin-home-card-icon i,
.admin-home-card-icon :deep(svg) {
    width: 24px;
    height: 24px;
}

.admin-home-card-icon i {
    display: flex;
    align-items: center;
    justify-content: center;
}

.admin-home-card.clickable:hover .admin-home-card-icon {
    color: #157ec2;
    background: rgba(21, 126, 194, 0.14);
    border-color: rgba(21, 126, 194, 0.2);
}

.admin-home-card-title {
    max-width: 100%;
    margin-bottom: 0;
    color: #22364c;
    font-size: 0.9rem;
    font-weight: 600;
    line-height: 1.25;
}

@media (max-width: 575.98px) {
    .admin-home-card {
        min-height: 116px;
        padding: 18px 12px 16px;
    }
}
</style>
